import React from "react";
import Button from "web/react/components/button/button";
import classnames from "classnames";
import styles from "./multiply-on-hover-button.css";
export default function MultiplyOnHoverButton(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      fullWidth = _ref.fullWidth,
      fullHeight = _ref.fullHeight,
      openInNewTab = _ref.openInNewTab,
      children = _ref.children;
  return React.createElement(Button, {
    styleType: "primary",
    className: classnames(className, styles.buttonMultiply),
    onClick: onClick,
    disabled: disabled,
    fullWidth: fullWidth,
    fullHeight: fullHeight,
    openInNewTab: openInNewTab
  }, React.createElement("div", {
    className: classnames(styles.multiplyLabel, styles.topLabel)
  }, children), React.createElement("div", {
    className: classnames(styles.multiplyLabel, styles.bottomLabel)
  }, children), React.createElement("div", {
    className: classnames(styles.multiplyLabel, styles.centerLabel)
  }, children));
}